var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _g3, _g4, _path12, _g5, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 173,
    viewBox: "0 0 353 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2459_2075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 29,
    width: 170,
    height: 144
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4426 34.8398C68.5351 34.8398 71.0421 37.3468 71.0421 40.4393V141.23C71.0421 144.322 68.5351 146.829 65.4426 146.829C62.3501 146.829 59.8432 144.322 59.8432 141.23V40.4393C59.8432 37.3468 62.3501 34.8398 65.4426 34.8398ZM132.636 46.0388C135.729 46.0388 138.236 48.5457 138.236 51.6382V130.031C138.236 133.123 135.729 135.63 132.636 135.63C129.544 135.63 127.037 133.123 127.037 130.031V51.6382C127.037 48.5457 129.544 46.0388 132.636 46.0388ZM87.8405 57.2377C90.933 57.2377 93.44 59.7447 93.44 62.8372V118.832C93.44 121.924 90.933 124.431 87.8405 124.431C84.748 124.431 82.241 121.924 82.241 118.832V62.8372C82.241 59.7447 84.748 57.2377 87.8405 57.2377ZM43.0448 74.0361C46.1373 74.0361 48.6442 76.5431 48.6442 79.6356V102.033C48.6442 105.126 46.1373 107.633 43.0448 107.633C39.9523 107.633 37.4453 105.126 37.4453 102.033V79.6356C37.4453 76.5431 39.9523 74.0361 43.0448 74.0361ZM110.238 79.6356C113.331 79.6356 115.838 82.1425 115.838 85.2351V96.434C115.838 99.5265 113.331 102.033 110.238 102.033C107.146 102.033 104.639 99.5265 104.639 96.434V85.2351C104.639 82.1425 107.146 79.6356 110.238 79.6356Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2459_2075)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2459_2075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.586 88.8888C163.586 125.499 133.908 155.178 97.297 155.178C60.6865 155.178 31.0078 125.499 31.0078 88.8888C31.0078 52.2783 60.6865 22.5996 97.297 22.5996C133.908 22.5996 163.586 52.2783 163.586 88.8888Z",
    fill: "#392AE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.586 88.8888C163.586 125.499 133.908 155.178 97.297 155.178C60.6865 155.178 31.0078 125.499 31.0078 88.8888C31.0078 52.2783 60.6865 22.5996 97.297 22.5996C133.908 22.5996 163.586 52.2783 163.586 88.8888Z",
    fill: "url(#paint0_radial_2459_2075)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.586 88.8888C163.586 125.499 133.908 155.178 97.297 155.178C60.6865 155.178 31.0078 125.499 31.0078 88.8888C31.0078 52.2783 60.6865 22.5996 97.297 22.5996C133.908 22.5996 163.586 52.2783 163.586 88.8888Z",
    fill: "url(#paint1_radial_2459_2075)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.586 88.8888C163.586 125.499 133.908 155.178 97.297 155.178C60.6865 155.178 31.0078 125.499 31.0078 88.8888C31.0078 52.2783 60.6865 22.5996 97.297 22.5996C133.908 22.5996 163.586 52.2783 163.586 88.8888Z",
    fill: "url(#paint2_radial_2459_2075)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.586 88.8888C163.586 125.499 133.908 155.178 97.297 155.178C60.6865 155.178 31.0078 125.499 31.0078 88.8888C31.0078 52.2783 60.6865 22.5996 97.297 22.5996C133.908 22.5996 163.586 52.2783 163.586 88.8888Z",
    fill: "url(#paint3_radial_2459_2075)",
    fillOpacity: 0.88
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.101 63.8408C45.3442 56.2382 38.1521 68.6505 47.3755 76.0467C51.7629 79.565 64.6423 81.7262 78.122 83.7434C71.9932 75.7029 65.9019 67.5992 59.101 63.8408Z",
    fill: "url(#paint4_radial_2459_2075)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.101 63.8408C45.3442 56.2382 38.1521 68.6505 47.3755 76.0467C51.7629 79.565 64.6423 81.7262 78.122 83.7434C71.9932 75.7029 65.9019 67.5992 59.101 63.8408Z",
    fill: "url(#paint5_linear_2459_2075)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2156 138.955C144.694 130.756 164.291 90.5664 146.704 64.9915C138.501 53.0636 125.655 55.278 98.2156 56.9207C70.7759 58.5635 43.5043 63.1705 43.5039 99.023C43.5035 134.876 76.8596 142.723 98.2156 138.955Z",
    fill: "url(#paint6_radial_2459_2075)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2156 138.955C144.694 130.756 164.291 90.5664 146.704 64.9915C138.501 53.0636 125.655 55.278 98.2156 56.9207C70.7759 58.5635 43.5043 63.1705 43.5039 99.023C43.5035 134.876 76.8596 142.723 98.2156 138.955Z",
    fill: "url(#paint7_linear_2459_2075)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0859 96.7954C69.0852 75.124 75.7829 54.9092 79.1529 45.3388C80.5395 41.401 85.7288 40.2798 89.1884 42.6165C95.0794 46.1687 106.947 54.7983 118.927 63.0713C131.376 71.6682 149.328 81.1724 141.089 109.356C134.847 130.71 104.388 129.744 104.388 129.744C104.388 129.744 69.087 129.156 69.0859 96.7954Z",
    fill: "url(#paint8_linear_2459_2075)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.208 128.756C154.466 113.655 160.458 82.0891 148.887 62.4776C137.315 42.866 120.829 38.2992 107.113 38.9422C93.3959 39.5851 65.5347 48.1619 64.358 78.9511C63.1812 109.74 79.1941 122.8 95.9429 137.514C102.415 143.2 119.949 143.857 137.208 128.756Z",
    fill: "url(#paint9_linear_2459_2075)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.514 120.611C139.047 119.361 139.578 118.237 140.169 117.371C147.882 106.083 144.884 90.7295 138.439 74.901C131.641 58.2056 119.801 31.2328 97.6245 29.5202C85.061 28.55 69.8734 40.0727 58.2037 54.3826C47.5735 67.4178 39.8447 82.6309 40.0259 95.4664C40.0713 98.6825 40.5451 102.552 41.6307 106.628C49.7453 129.987 64.8755 141.182 92.454 139.565C120.033 137.948 125.012 135.019 138.514 120.611Z",
    fill: "url(#paint10_linear_2459_2075)",
    fillOpacity: 0.78
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1483 94.9014C48.9481 72.669 58.3766 48.7012 79.9393 48.7012C96.9625 48.7012 106.582 61.7153 119.66 70.2639C135.721 80.762 148.032 88.002 148.032 98.6358C148.032 117.929 119.268 128.175 91.8318 117.192C71.8134 109.179 55.3484 117.134 52.1483 94.9014Z",
    fill: "url(#paint11_radial_2459_2075)",
    fillOpacity: 0.8
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5358 52.4716C68.4375 36.3897 91.9729 36.0024 100.208 54.8258C104.372 64.3435 103.574 77.8748 102.679 91.4376C89.8807 76.399 76.209 60.9036 73.5358 52.4716Z",
    fill: "url(#paint12_linear_2459_2075)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2317 99.991C44.9011 75.3094 54.7139 48.7012 77.1557 48.7012C94.8729 48.7012 104.885 63.149 118.496 72.6393C135.211 84.294 148.024 92.3315 148.024 104.137C148.024 125.555 118.088 136.93 89.533 124.738C68.6986 115.841 51.5623 124.673 48.2317 99.991Z",
    fill: "url(#paint13_linear_2459_2075)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6352 134.471C86.5866 142.148 105.279 125.892 90.5035 113.586C86.0738 109.896 74.5839 114.189 62.3727 111.614C52.0261 108.527 46.7461 104.36 41.9202 85.3767C41.9202 106.348 52.6837 126.794 69.6352 134.471Z",
    fill: "url(#paint14_radial_2459_2075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6352 134.471C86.5866 142.148 105.279 125.892 90.5035 113.586C86.0738 109.896 74.5839 114.189 62.3727 111.614C52.0261 108.527 46.7461 104.36 41.9202 85.3767C41.9202 106.348 52.6837 126.794 69.6352 134.471Z",
    fill: "url(#paint15_linear_2459_2075)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_df_2459_2075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.143 90.279C106.143 103.846 103.83 114.433 86.4942 114.433C69.1578 114.433 51.1029 109.532 51.1029 95.9654C51.1029 90.7489 49.8574 86.8585 53.4006 82.8807C56.9846 78.8571 57.8041 77.101 57.8041 69.9504C59.085 60.8151 61.9998 55.4101 69.1178 51.9022C69.1475 51.8875 69.1818 51.8797 69.215 51.8797C82.3441 51.8712 86.545 48.6356 92.195 62.6421C92.2027 62.661 92.2035 62.6826 92.1965 62.7017C90.7288 66.724 94.694 75.0638 97.8033 78.4485C101.507 82.4807 106.143 84.9339 106.143 90.279Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_df_2459_2075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3972 88.3619C89.3972 98.331 87.6977 106.11 74.9601 106.11C62.2224 106.11 48.9567 102.509 48.9567 92.5403C48.9567 88.7071 48.0416 85.8485 50.6449 82.9256C53.2782 79.969 53.8803 78.6787 53.8803 73.4244C54.8208 66.7169 56.9598 62.7463 62.1808 60.1685C62.2106 60.1538 62.2449 60.146 62.2781 60.1459C71.9113 60.1375 74.9978 57.7683 79.1455 68.0462C79.1531 68.0651 79.1539 68.0866 79.147 68.1058C78.0766 71.0643 80.9868 77.1839 83.2693 79.6688C85.9909 82.6316 89.3972 84.4343 89.3972 88.3619Z",
    fill: "white",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2459_2075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 44,
    width: 184,
    height: 90
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.625 133.196C182.087 133.196 176.625 131.92 172.24 129.369C167.854 126.738 164.625 123.269 162.552 118.963C160.479 114.578 159.442 109.794 159.442 104.611C159.442 98.7906 160.638 93.6876 163.03 89.3022C165.502 84.9168 168.891 81.5679 173.196 79.2556C177.502 76.8636 182.366 75.6676 187.788 75.6676C196.24 75.6676 202.499 78.0197 206.565 82.7241C210.711 87.3487 212.785 93.8869 212.785 102.339C212.785 104.492 212.665 106.724 212.426 109.036H172.957C173.834 113.9 175.549 117.409 178.1 119.561C180.731 121.714 184.359 122.791 188.984 122.791C192.811 122.791 195.961 122.472 198.432 121.834C200.904 121.196 203.177 120.319 205.25 119.203L209.197 128.412C207.203 129.688 204.492 130.804 201.064 131.761C197.635 132.718 193.489 133.196 188.625 133.196ZM200.226 100.066C200.306 95.1228 199.23 91.6543 196.997 89.661C194.765 87.5879 191.575 86.5513 187.429 86.5513C179.057 86.5513 174.233 91.0563 172.957 100.066H200.226ZM226.207 44.0927H239.004V132H226.207V44.0927ZM257.014 44.0927H269.811V132H257.014V44.0927ZM311.023 133.196C306.08 133.196 301.495 132.04 297.269 129.728C293.123 127.336 289.774 123.987 287.223 119.681C284.751 115.296 283.515 110.193 283.515 104.372C283.515 98.6311 284.591 93.6078 286.744 89.3022C288.977 84.9965 292.126 81.6477 296.193 79.2556C300.259 76.8636 305.043 75.6676 310.545 75.6676C313.734 75.6676 316.724 76.2257 319.515 77.342C322.306 78.4583 324.658 79.8536 326.572 81.528C328.485 83.1227 329.761 84.7174 330.399 86.3121L330.638 77.1028H342.957V132H330.758L330.518 122.312C329.163 125.183 326.691 127.734 323.103 129.967C319.515 132.12 315.489 133.196 311.023 133.196ZM313.176 122.432C317.721 122.432 321.548 120.877 324.658 117.767C327.768 114.578 329.322 110.432 329.322 105.329V104.492C329.322 101.063 328.605 97.9932 327.17 95.2823C325.734 92.5713 323.781 90.4583 321.309 88.9434C318.837 87.4284 316.126 86.6709 313.176 86.6709C308.073 86.6709 304.126 88.3454 301.336 91.6942C298.545 94.9633 297.15 99.2291 297.15 104.492C297.15 109.834 298.505 114.179 301.216 117.528C304.007 120.797 307.993 122.432 313.176 122.432Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2459_2075)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2459_2075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.583 105.097C446.583 175.182 371.726 231.998 279.385 231.998C187.045 231.998 112.188 175.182 112.188 105.097C112.188 35.0124 187.045 -21.8027 279.385 -21.8027C371.726 -21.8027 446.583 35.0124 446.583 105.097Z",
    fill: "#3834FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.583 105.097C446.583 175.182 371.726 231.998 279.385 231.998C187.045 231.998 112.188 175.182 112.188 105.097C112.188 35.0124 187.045 -21.8027 279.385 -21.8027C371.726 -21.8027 446.583 35.0124 446.583 105.097Z",
    fill: "url(#paint16_radial_2459_2075)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.583 105.097C446.583 175.182 371.726 231.998 279.385 231.998C187.045 231.998 112.188 175.182 112.188 105.097C112.188 35.0124 187.045 -21.8027 279.385 -21.8027C371.726 -21.8027 446.583 35.0124 446.583 105.097Z",
    fill: "url(#paint17_radial_2459_2075)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.583 105.097C446.583 175.182 371.726 231.998 279.385 231.998C187.045 231.998 112.188 175.182 112.188 105.097C112.188 35.0124 187.045 -21.8027 279.385 -21.8027C371.726 -21.8027 446.583 35.0124 446.583 105.097Z",
    fill: "url(#paint18_radial_2459_2075)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.583 105.097C446.583 175.182 371.726 231.998 279.385 231.998C187.045 231.998 112.188 175.182 112.188 105.097C112.188 35.0124 187.045 -21.8027 279.385 -21.8027C371.726 -21.8027 446.583 35.0124 446.583 105.097Z",
    fill: "url(#paint19_radial_2459_2075)",
    fillOpacity: 0.88
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.633 90.2224C138.239 77.89 122.349 98.0243 142.727 110.022C152.42 115.729 180.875 119.235 210.657 122.507C197.116 109.464 183.658 96.3191 168.633 90.2224Z",
    fill: "url(#paint20_radial_2459_2075)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.633 90.2224C138.239 77.89 122.349 98.0243 142.727 110.022C152.42 115.729 180.875 119.235 210.657 122.507C197.116 109.464 183.658 96.3191 168.633 90.2224Z",
    fill: "url(#paint21_linear_2459_2075)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.041 212.063C357.729 198.763 401.026 133.57 362.169 92.0835C344.047 72.7349 315.665 76.327 255.041 78.9917C194.418 81.6564 134.165 89.1296 134.164 147.287C134.163 205.445 207.859 218.174 255.041 212.063Z",
    fill: "url(#paint22_radial_2459_2075)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M255.041 212.063C357.729 198.763 401.026 133.57 362.169 92.0835C344.047 72.7349 315.665 76.327 255.041 78.9917C194.418 81.6564 134.165 89.1296 134.164 147.287C134.163 205.445 207.859 218.174 255.041 212.063Z",
    fill: "url(#paint23_linear_2459_2075)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.684 143.677C190.682 108.523 205.48 75.7317 212.925 60.2073C215.989 53.8196 227.454 52.0009 235.097 55.7914C248.112 61.5535 274.333 75.5519 300.801 88.9718C328.305 102.917 367.967 118.334 349.764 164.052C335.973 198.691 268.678 197.124 268.678 197.124C268.678 197.124 190.686 196.171 190.684 143.677Z",
    fill: "url(#paint24_linear_2459_2075)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.105 168.778C400.235 144.282 413.473 93.0775 387.908 61.2649C362.343 29.4523 325.92 22.0442 295.615 23.0872C265.309 24.1302 203.754 38.0428 201.155 87.9873C198.555 137.932 233.933 159.116 270.937 182.985C285.235 192.207 323.975 193.273 362.105 168.778Z",
    fill: "url(#paint25_linear_2459_2075)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.272 140.605C146.202 104.541 167.032 65.6621 214.672 65.6621C252.282 65.6621 273.535 86.7729 302.429 100.64C337.913 117.669 365.113 129.413 365.113 146.663C365.113 177.959 301.563 194.58 240.947 176.764C196.719 163.765 160.342 176.669 153.272 140.605Z",
    fill: "url(#paint26_radial_2459_2075)",
    fillOpacity: 0.8
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.522 71.7779C189.258 45.6908 241.256 45.0626 259.451 75.5966C268.651 91.0357 266.886 112.985 264.909 134.986C236.634 110.591 206.428 85.4557 200.522 71.7779Z",
    fill: "url(#paint27_linear_2459_2075)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M144.616 148.857C137.257 108.82 158.937 65.6582 208.519 65.6582C247.663 65.6582 269.782 89.0946 299.854 104.489C336.784 123.395 365.093 136.433 365.093 155.582C365.093 190.326 298.952 208.778 235.865 189C189.834 174.569 151.974 188.894 144.616 148.857Z",
    fill: "url(#paint28_linear_2459_2075)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.898 204.791C229.35 217.244 270.649 190.875 238.004 170.912C228.217 164.927 202.832 171.891 175.853 167.715C152.994 162.707 141.328 155.947 130.666 125.154C130.666 159.171 154.447 192.338 191.898 204.791Z",
    fill: "url(#paint29_radial_2459_2075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.898 204.791C229.35 217.244 270.649 190.875 238.004 170.912C228.217 164.927 202.832 171.891 175.853 167.715C152.994 162.707 141.328 155.947 130.666 125.154C130.666 159.171 154.447 192.338 191.898 204.791Z",
    fill: "url(#paint30_linear_2459_2075)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2459_2075",
    x: 29.5128,
    y: 21.621,
    width: 135.568,
    height: 135.568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.516462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.747511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.145098 0 0 0 0 0.258824 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2459_2075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2459_2075",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_2459_2075",
    x: 49.2597,
    y: 49.9198,
    width: 59.0594,
    height: 66.6883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.271822,
    dy: 0.271822
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.951378
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2459_2075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2459_2075",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.339778,
    result: "effect2_foregroundBlur_2459_2075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_df_2459_2075",
    x: 47.1698,
    y: 58.2734,
    width: 44.4032,
    height: 50.0106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.271822,
    dy: 0.271822
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.951378
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2459_2075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2459_2075",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.339778,
    result: "effect2_foregroundBlur_2459_2075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2459_2075",
    x: 110.692,
    y: -22.7813,
    width: 337.385,
    height: 256.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.516462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.747511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.145098 0 0 0 0 0.258824 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2459_2075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2459_2075",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.7238 44.3694) rotate(63.1327) scale(49.9066 59.2025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7194",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.056 67.5118) rotate(161.19) scale(66.3002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8F9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.263 151.648) rotate(-108.939) scale(42.2988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4763",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1242 112.816) rotate(-18.3418) scale(76.0357 105.692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3041",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6696 60.8559) rotate(70.7014) scale(20.9031 26.8371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2459_2075",
    x1: 74.2684,
    y1: 81.2984,
    x2: 66.4755,
    y2: 74.6324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.9888 68.2057) rotate(69.3277) scale(52.8864 63.7171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B850C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCADE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2459_2075",
    x1: 101.794,
    y1: 55.53,
    x2: 101.302,
    y2: 71.9899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCADE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2459_2075",
    x1: 76.5387,
    y1: 106.994,
    x2: 113.41,
    y2: 92.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2459_2075",
    x1: 154.665,
    y1: 85.029,
    x2: 109.585,
    y2: 105.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BAEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BAEEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2459_2075",
    x1: 92.0224,
    y1: 123.106,
    x2: 95.8369,
    y2: 51.1051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1678 60.1186) rotate(84.3771) scale(43.7515 48.8653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65ECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BECE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2459_2075",
    x1: 72.8203,
    y1: 51.6876,
    x2: 101.246,
    y2: 46.9807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E375A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E375A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2459_2075",
    x1: 129.264,
    y1: 116.585,
    x2: 144.074,
    y2: 90.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AE52F7",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.485 105.528) rotate(49.5763) scale(51.3012 65.8648)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2459_2075",
    x1: 45.4973,
    y1: 105.623,
    x2: 57.9688,
    y2: 116.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.972 19.8721) rotate(56.2773) scale(102.467 139.226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7194",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.68 64.1746) rotate(165.505) scale(163.499 129.814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8F9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.789 225.241) rotate(-114.328) scale(84.0546 102.779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4763",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.3475 150.902) rotate(-14.1238) scale(187.712 206.716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3041",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.633 85.3805) rotate(64.5022) scale(35.4556 56.7039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2459_2075",
    x1: 202.143,
    y1: 118.541,
    x2: 189.495,
    y2: 103.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.679 97.2975) rotate(62.8011) scale(90.2442 133.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B850C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCADE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2459_2075",
    x1: 262.946,
    y1: 76.7358,
    x2: 262.361,
    y2: 103.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCADE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2459_2075",
    x1: 207.149,
    y1: 160.22,
    x2: 280.579,
    y2: 121.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2459_2075",
    x1: 400.674,
    y1: 97.8464,
    x2: 313.641,
    y2: 151.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BAEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BAEEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.549 84.1828) rotate(82.3625) scale(71.2616 107.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65ECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BECE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2459_2075",
    x1: 198.941,
    y1: 70.5061,
    x2: 260.343,
    y2: 56.6582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E375A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E375A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2459_2075",
    x1: 323.644,
    y1: 175.775,
    x2: 343.447,
    y2: 127.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AE52F7",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2459_2075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.008 157.841) rotate(40.7605) scale(97.0305 124.803)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2459_2075",
    x1: 138.569,
    y1: 157.995,
    x2: 158.579,
    y2: 182.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElla);
export default __webpack_public_path__ + "static/media/Ella.5b3a1a9b122b72bb5a398e82f0b577fb.svg";
export { ForwardRef as ReactComponent };